import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class SimpleText {
	constructor() {
		this.sections = document.querySelectorAll('.simple');
		this.animate();
	}

	animate() {
		this.sections.forEach((section) => {
			const surtitle = section.querySelectorAll('.surtitle');
			const surtitleAnimation = TweenMax.staggerFromTo(
				surtitle,
				0.5,
				{ x: -300, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1 }
			);
			const title = section.querySelectorAll('.title');
			const titleAnimation = TweenMax.staggerFromTo(title, 0.5, { x: -300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
			const simpleTextBorder = section.querySelectorAll('.simple-text--border');
			const simpleTextBorderAnimation = TweenMax.staggerFromTo(
				simpleTextBorder,
				0.5,
				{ x: -300, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1 }
			);
			const simpleText = section.querySelectorAll('.simple-text');
			const simpleTextAnimation = TweenMax.staggerFromTo(
				simpleText,
				0.5,
				{ x: 300, autoAlpha: 0 },
				{ x: 0, autoAlpha: 1 }
			);

			const timeline = new TimelineLite();
			timeline
				.add(surtitleAnimation, 0.1)
				.add(titleAnimation, 0.1)
				.add(simpleTextBorderAnimation, 0.1)
				.add(simpleTextAnimation, 0.1);

			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 0.85,
				offset: 0,
				reverse: false,
			})
				.setTween(timeline)
				.addTo(ScrollMagicController.controller);
		});
	}
}

export default SimpleText;
